export const SARA_SUGGESTION_CYCLE_MS = 5000

type SaraSuggestion = { en: string; sv: string }

/** Fetch a specific product or product pair. */
export const SARA_PRODUCT_PROMPTS: SaraSuggestion[] = [
  {
    en: 'find black hoodies for our team',
    sv: 'hitta svarta hoodies till vårt team',
  },
  {
    en: 'find 50 organic t-shirts in white',
    sv: 'hitta 50 ekologiska t-shirts i vitt',
  },
  {
    en: 'find a cap and a tote bag',
    sv: 'hitta en keps och en totebag',
  },
  {
    en: 'find sustainable drinkware',
    sv: 'hitta hållbara muggar',
  },
  {
    en: 'show me bags we can brand',
    sv: 'visa väskor vi kan branda',
  },
  {
    en: 'find navy polo shirts',
    sv: 'hitta navy-pikétröjor',
  },
  {
    en: 'find water bottles we can print on',
    sv: 'hitta vattenflaskor vi kan trycka på',
  },
  {
    en: 'find pens and notebooks for the office',
    sv: 'hitta pennor och anteckningsböcker till kontoret',
  },
]

/** Fetch or assemble a kit. */
export const SARA_KIT_PROMPTS: SaraSuggestion[] = [
  {
    en: 'create an onboarding kit',
    sv: 'skapa ett onboardingkit',
  },
  {
    en: 'build a conference swag pack',
    sv: 'sätt ihop ett konferenskit',
  },
  {
    en: 'suggest a summer campaign kit',
    sv: 'föreslå ett sommarkampanjkit',
  },
  {
    en: 'put together a new-hire welcome kit',
    sv: 'sätt ihop ett välkomstkit för nyanställda',
  },
  {
    en: 'find a team kit with a hoodie, tote and mug',
    sv: 'hitta ett teamkit med hoodie, tote och mugg',
  },
  {
    en: 'build a client gift kit',
    sv: 'sätt ihop ett kundgåvokit',
  },
  {
    en: 'create a booth giveaway kit',
    sv: 'skapa ett kit till mässmontern',
  },
  {
    en: 'suggest a kit for 50 people',
    sv: 'föreslå ett kit till 50 personer',
  },
]
